var _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgStart = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.771 0.101251C11.1027 -0.242697 10.2334 0.312291 8.49493 1.42227L8.04516 1.70943C7.55113 2.02485 7.30412 2.18256 7.02689 2.22782C6.74967 2.27308 6.47362 2.20077 5.92153 2.05615L5.41889 1.92448C3.47605 1.41555 2.50463 1.16109 1.94841 1.70496C1.39219 2.24883 1.61954 3.23084 2.07423 5.19488L2.19187 5.703C2.32108 6.26111 2.38568 6.54017 2.33323 6.81727C2.28077 7.09437 2.11719 7.33814 1.79003 7.82567L1.49217 8.26954C0.340875 9.9852 -0.234773 10.843 0.0897422 11.5231C0.414257 12.2032 1.42402 12.2551 3.44353 12.359L3.96602 12.3859C4.5399 12.4154 4.82685 12.4301 5.07165 12.5561C5.31645 12.6821 5.4914 12.9051 5.8413 13.351L6.15985 13.757C7.39115 15.3263 8.00681 16.1109 8.76359 15.9874C9.52037 15.8638 9.91709 14.9139 10.7105 13.014L10.9158 12.5225C11.1413 11.9826 11.254 11.7127 11.4578 11.5135C11.6615 11.3142 11.9332 11.2083 12.4766 10.9963L12.9714 10.8034C14.8836 10.0576 15.8398 9.6847 15.983 8.92826C16.1262 8.17182 15.3616 7.5328 13.8325 6.25477L13.4369 5.92413C13.0023 5.56096 12.785 5.37936 12.6662 5.13024C12.5473 4.88111 12.5403 4.59265 12.5262 4.01574L12.5134 3.4905C12.464 1.4603 12.4393 0.4452 11.771 0.101251Z",
    fill: "url(#paint0_linear_4099_3349)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0243 13.1757C13.7899 12.9414 13.4101 12.9414 13.1757 13.1757C12.9414 13.4101 12.9414 13.7899 13.1757 14.0243L14.7757 15.6243C15.01 15.8586 15.3899 15.8586 15.6243 15.6243C15.8586 15.3899 15.8586 15.0101 15.6243 14.7757L14.0243 13.1757Z",
    fill: "url(#paint1_linear_4099_3349)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4099_3349",
    x1: 8,
    y1: 0,
    x2: 8,
    y2: 16,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE7AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.526042,
    stopColor: "#FEB914"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8A00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4099_3349",
    x1: 8,
    y1: 0,
    x2: 8,
    y2: 16,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE7AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.526042,
    stopColor: "#FEB914"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8A00"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgStart, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/Start.72b73e37.svg";
export { ForwardRef as ReactComponent };